export const getCoTraveller = (data) => {
    let result = {};
    result.salutation = data.salutation;
    result.first_name = data.first_name;
    result.last_name = data.last_name;
    result.date_of_birth = data.date_of_birth;
    result.identification = data.identification;
    result.identification_number = data.identification_number;
    result.nationality = data.nationality;
    result.address = {};
    result.address.street = data.street;
    result.address.city = data.city;
    result.address.country = data.country;
    result.address.zip_code = data.zip_code;
    result.email = data.email;
    result.phone = data.phone;
    result.mobile = data.mobile;
    result.member_id = data.member_id;
    return result;
};
